import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  constructor() { }

  public _sharedSavingProductGroupCycleMemberOutputDto: any;
  public contributionName: any;
  public _selectedModuleName:string;
}
